import { createSelector } from 'reselect'

const getBoardId = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].boardId
}

const getCardId = (state, props) => props.cardContext.id

export const getElement = (state, props) => {
  return state['view-card'].elements.elementsById[props.id]
}

export const getIsCardArchived = (state, props) => {
  return state['view-board'].cards[props.cardContext.id].isArchived
}

export const getDocumentListItems = (state, props) => {
  return state['view-card'].documentListItems
}

export default () => createSelector(
  [getBoardId, getCardId, getElement, getIsCardArchived, getDocumentListItems],
  (boardId, cardId, element, isCardArchived, documentListItems) => ({
    boardId,
    cardId,
    isCardArchived,
    items: element.items,
    latestDocumentUpdate:
      element.items.length > 0
        ? Math.max(...element.items.map(itemId => documentListItems[itemId].lastModificationTimestamp))
        : null,
    isBusy: element.isBusy
  })
)
